import { useState, useRef, useEffect } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

// Triggers a background re-roll of a saved quote's AI visuals, then polls until done.
// onDone receives { status, updated_at, photo_url, interior_photo_url }.
export function RegenerateVisualsButton({ quoteId, onDone, testid = "regenerate-visuals", small }) {
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  const poll = (attempt = 0) => {
    timer.current = setTimeout(async () => {
      try {
        const r = await api.get(`/admin/quote/${quoteId}/render-status`);
        if (r.data.status === "generating" && attempt < 45) return poll(attempt + 1);
        setBusy(false);
        if (r.data.status === "error") { toast.error("Couldn't regenerate the visuals — please try again."); return; }
        toast.success("Visuals regenerated");
        if (onDone) onDone(r.data);
      } catch (e) { setBusy(false); toast.error("Couldn't check render status — refresh to see the new visuals."); }
    }, 4000);
  };

  const go = async (e) => {
    e?.stopPropagation?.();
    setBusy(true);
    try {
      await api.post(`/admin/quote/${quoteId}/regenerate-renders`);
      toast.info("Regenerating visuals — this takes about a minute…");
      poll(0);
    } catch (err) { setBusy(false); toast.error(err?.response?.data?.detail || "Could not start regeneration"); }
  };

  return (
    <button data-testid={testid} onClick={go} disabled={busy}
      className={`inline-flex items-center gap-1.5 border border-[#E5E7EB] bg-white font-bold uppercase tracking-widest hover:border-[#C79A3B] disabled:opacity-60 transition-colors ${small ? "text-[10px] px-2 py-1" : "text-xs px-3 py-1.5"}`}>
      <RefreshCw size={small ? 12 : 13} className={busy ? "animate-spin" : ""} /> {busy ? "Regenerating…" : "Regenerate visuals"}
    </button>
  );
}
